/**
 * @namespace am
 * Global namespace for Archelios MAP
 */
var am = (function(module) {

    //Use strict mode
    'use strict';
  
    /**
     * @class am.MainController
     * This class contains all the logic of the application
     */
    module.MainController = function(sDataVersion,sTradVersion) { //#3038 ajout des versions
        // Private attributes
        this._map = undefined;  // reference to the map
        this._controllers = []; // references to the (sub)controllers
        this._infoPopupDisplayed = false; // has the info popup regarding the "multiselectability" of the roofsides been already displayed?
        this._userid = "null";
        this._el = null;
        this._address = null;
        this._config = undefined;
        this._loadingProject = false;

        this._sDataVersion=sDataVersion || "1";
        this._sTradVersion=sTradVersion || "1";
        this._marker = L.marker([0., 0.], {
            interactive: false,
            icon: L.icon({
                iconUrl: '/img/pics/marker.png',
                iconSize: L.point(40, 40),
                iconAnchor: L.point(25, 50)
            })
        });
    };

    /**
     * Class constructor
     * @constructor
     */
    module.MainController.prototype.init = function(el) {
        // Amélioration du côté responsive de l'application : on maintient les boutons CTA visibles,
        // même en présence de la barre de recherche d'adresse ou de la barre de navigation
        var body = el.get(0);
        var viewport = window.visualViewport;
        if (viewport) {
            viewport.onresize = am.utils.debouncedAnimationFrame(function() {
                body.style.setProperty('--page-height', viewport.height + 'px');
                body.style.setProperty('--page-margin-top', viewport.offsetTop + 'px');
            });
            viewport.onresize(); // appel de la fonction
            if (bowser.mobile || bowser.tablet) {
                var addBottomGap;
                if (bowser.ios) {
                    addBottomGap = bowser.compareVersions([bowser.osversion, '13.0']) < 0;
                } else {
                    addBottomGap = !(bowser.firefox || bowser.chrome || bowser.samsungBrowser || bowser.opera) ||
                        (bowser.firefox && bowser.compareVersions([bowser.version, '110.0']) < 0) ||
                        (bowser.chrome && bowser.compareVersions([bowser.version, '109.0']) < 0) ||
                        (bowser.samsungBrowser && bowser.compareVersions([bowser.version, '8.2']) < 0) ||
                        (bowser.opera && bowser.compareVersions([bowser.version, '72.0']) < 0);
                }
                if (addBottomGap) {
                    body.classList.add('am-add-bottom-gap');
                }
            }
        } else {
            body.classList.add('am-add-bottom-gap');
            window.onresize = am.utils.debouncedAnimationFrame(function() {
                body.style.setProperty('--page-height', window.innerHeight + 'px');
            });
            window.onresize(); // appel de la fonction
        }

        // Get the configuration of the main controller, then instantiate the various components of the controller
        var _this = this;
        this._initUI(el);

        // If the browser is not supported, we redirect to the home page
        if (g_bUnsupported && window.location.href.indexOf('?') !== -1) {
            window.location.replace(window.location.origin);
        }
        // Otherwise we initialize the app
        else {
            Promise.all([this._getConfig(), this._getGeographicDelimitations(), this._getJsonEPCI(), this._getGeographicDelimitationsEPCI(), this._getOuterDelimitations()]).then(function(files) {
                var config = _this._config = files[0];
                var geographicBorders = files[1];
                var epciJson = files[2];
                var geographicBordersEPCI = files[3];
                var outerDelimitations = files[4];

                if (outerDelimitations !== undefined)
                    _this._config.outerDelimitations = outerDelimitations;
                if (geographicBorders !== undefined) {
                    _this._config.geographicBorders = geographicBorders;
                } else if (geographicBordersEPCI !== undefined) {
                    _this._config.geographicBordersEPCI = geographicBordersEPCI;
                } else if (epciJson !== undefined) {
                    _this._config.initialState = _this._config.initialState || {};
                    var oParams = _this._config.initialState;
                    
                    epciJson.features.forEach(function (oEpci) {
                        oParams.epciJson = epciJson;
                        oParams.epciJson.features = [oEpci];

                        oParams.epciCenter = turf.centroid(oEpci);
                        oParams.epciLat = oParams.epciCenter.geometry["coordinates"][1];
                        oParams.epciLng = oParams.epciCenter.geometry["coordinates"][0];
                        oParams.epciBounds = turf.bbox(oEpci);

                        var epciBoundingMin = [oParams.epciBounds[1], oParams.epciBounds[0]],
                            epciBoundingMax = [oParams.epciBounds[3], oParams.epciBounds[2]];

                        _this._config["mapOptions"].epciMaxBoundsArray = [epciBoundingMin, epciBoundingMax];
                        _this._config["mapOptions"].epciMaxBounds = L.latLngBounds(
                            L.latLng(epciBoundingMin[0], epciBoundingMin[1]),
                            L.latLng(epciBoundingMax[0], epciBoundingMax[1])
                        );

                        _this._config["mapOptions"].epciMaxBounds["lowerLeftCorner"] = epciBoundingMin;
                        _this._config["mapOptions"].epciMaxBounds["upperRightCorner"] = epciBoundingMax;

                        oParams.lng = parseFloat(oEpci.properties["LNG_COMM"]);
                        oParams.lngLen = parseFloat(oEpci.properties["BOUNDS_LNG"]);
                        oParams.lat = parseFloat(oEpci.properties["LAT_COMM"]);
                        oParams.latLen = parseFloat(oEpci.properties["BOUNDS_LAT"]);
                        oParams.center = turf.point([oParams.lng, oParams.lat]);

                        oParams.bounds = [
                            oParams.lng - oParams.lngLen * 0.5,
                            oParams.lat - oParams.latLen * 0.5,
                            oParams.lng + oParams.lngLen * 0.5,
                            oParams.lat + oParams.latLen * 0.5,
                        ];

                        _this._config["mapOptions"].maxBoundsArray = [epciBoundingMin, epciBoundingMax];
                        _this._config["mapOptions"].maxBounds = L.latLngBounds(
                            L.latLng(epciBoundingMin[0], epciBoundingMin[1]),
                            L.latLng(epciBoundingMax[0], epciBoundingMax[1])
                        );

                        _this._config["mapOptions"].maxBounds["lowerLeftCorner"] = epciBoundingMin;
                        _this._config["mapOptions"].maxBounds["upperRightCorner"] = epciBoundingMax;
                    });
                }

                // Initialisation du suivi des clics
                _this._userid = am.utils.generateUid();
                _this._trackingClick("loadProject");

                // On assigne une classe portant le nom du projet à la balise <body>
                if (config.projectId != undefined) {
                    $(document.body).addClass(config.projectId);
                }

                // Initialisation de l'application
                var displayWelcomingModal = window.location.href.indexOf('?') == -1; // URL contains some information
                _this._instantiateGlobalObjects(config);
                _this._instantiatePageHeader(config);
                _this._instantiateMap(config, displayWelcomingModal, geographicBorders, geographicBordersEPCI, outerDelimitations);
                _this._instantiateControllers(config);
                _this._registerEventHandlers(config);
                _this._defineViewCallbacks(config);
                _this._loadProject();

                window.onpopstate = function() {
                    _this._loadProject();
                };
            });
        }
    };

    /**
     * Class destructor
     */
    module.MainController.prototype.destroy = function() {
        // Destroy the (sub)controllers
        this._controllers.forEach(function(ctrl) {
            ctrl.destroy();
        });

        // Unregister event handlers
        this._unregisterEventHandlers();
    };

    /**
     * Returns a reference to the instance of class L.Map used in the present application
     *
     * @return {L.Map} - Reference to the instance of L.Map used to display the buildings and roofs
     */
    module.MainController.prototype.getMapObject = function() {
        return this._map;
    };

    /**
     * Returns the configuration of the application
     *
     * @return {Object} - Application configuration
     */
    module.MainController.prototype.getConfig = function() {
        return this._config;
    };

    /**
     * Class init User Interface
     */
    module.MainController.prototype._initUI = function(el) {
        this._el = el;
        // var el = $('body');
        if ($(window).width()<=1024) {
            $(this._el).addClass("mobile-view-activated");
        } else {
            $(this._el).addClass("desktop-detected");
        }
    };


    module.MainController.prototype._getJsonEPCI = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            $.ajax({
                dataType: "json",
                url: "/data/boundary.geojson?rev=" + _this._sDataVersion,
                success: function (oData) {
                    console.log("Successfully loaded EPCI boundaries associated with project '" + oData.projectId + "'");
                    resolve(oData);
                },
                error: function (jqXHR, textStatus) {
                    console.warn("Cannot load EPCI boundaries: " + textStatus);
                    resolve(undefined); // do not throw an error for backwards compatibility
                }
            });
        });
    };

    /**
     * Returns the configuration of the current project as a Promise
     *
     * @return {Promise} - Promise evaluating to the configuration of the current project
     */
    module.MainController.prototype._getConfig = function() {
        var _this=this;
        return new Promise(function(resolve,reject){
            $.ajax({
                dataType: "json",
                url: "/data/config.js?rev="+_this._sDataVersion,//#2306 en JS pour le cache ( ne pas requeter des .json (statique))
                success: function(data) {
                    console.log("Successfully loaded config file associated with project '" + data.projectId + "'");
                    am.translator = am.utils.translator(data,_this._sTradVersion,function(){//#2306 deplacement de l'initialisation de la traduction car async
                        resolve(data);
                    });
                },
                error: function(jqXHR, textStatus) {
                    console.log("Cannot load config file: " + textStatus);
                    reject(jqXHR, textStatus);
                }
            });
        });
    };

    module.MainController.prototype._getOuterDelimitations = function() {
        var _this=this;
        return new Promise(function(resolve,reject){
            $.ajax({
                dataType: "json",
                url: "/data/outer_delimitations.geojson?rev=" + _this._sDataVersion,
                success: function(data) {
                    console.log("Successfully loaded outer delimitations GeoJSON file associated with project '" + data.projectId + "'");
                    resolve(data);
                },
                error: function(jqXHR, textStatus) {
                    console.warn("Cannot load geoJSON file: " + textStatus);
                    resolve(undefined); // do not throw an error for backwards compatibility
                }
            });
        });
    };

    /**
     * Returns the contents of the GeoJSON specifying the geographic delimitations of the current project
     *
     * @return {Promise} - Promise evaluating to the geographic delimitations of the current project
     */
     module.MainController.prototype._getGeographicDelimitations = function() {
        var _this=this;
        return new Promise(function(resolve,reject){
            $.ajax({
                dataType: "json",
                url: "/data/geographic_delimitations_public.geojson?rev=" + _this._sDataVersion,
                success: function(data) {
                    console.log("Successfully loaded GeoJSON file associated with project '" + data.projectId + "'");
                    resolve(data);
                },
                error: function(jqXHR, textStatus) {
                    console.warn("Cannot load geoJSON file: " + textStatus);
                    resolve(undefined); // do not throw an error for backwards compatibility
                }
            });
        });
    };

    /**
     * Returns the contents of the GeoJSON specifying the geographic delimitations EPCI of the current project
     *
     * @return {Promise} - Promise evaluating to the geographic delimitations of the current project
     */
        module.MainController.prototype._getGeographicDelimitationsEPCI = function() {
            var _this=this;
            return new Promise(function(resolve,reject){
                $.ajax({
                    dataType: "json",
                    url: "/data/epci_geographic_delimitations.geojson?rev=" + _this._sDataVersion,
                    success: function(data) {
                        console.log("Successfully loaded GeoJSON file associated with project '" + data.projectId + "'");
                        resolve(data);
                    },
                    error: function(jqXHR, textStatus) {
                        console.warn("Cannot load geoJSON file: " + textStatus);
                        resolve(undefined); // do not throw an error for backwards compatibility
                    }
                });
            });
        };
    

    /**
     * Instantiates the global objects of the application according to the information contained in the config object
     *
     * @param {Object} config - Object containing the configuration of the current project
     */    
    module.MainController.prototype._instantiateGlobalObjects = function(config) {
        am.eventManager    = am.utils.eventManager(config);
        am.templateManager = am.utils.templateManager(config);
        am.solarInstallationModel = am.utils.solarInstallationModel(config);
    };


    /**
     * Instantiates the main page header according to the information contained in the config object
     *
     * @param {Object} config - Object containing the configuration of the current project
     */    
    module.MainController.prototype._instantiatePageHeader = function(config) {
        var $headerRibbon = $('#header-ribbon');
        if ($headerRibbon.length > 0) {
            $('body').addClass('header-ribbon-present');
            am.templateManager.fillElementWithTemplate($headerRibbon, 'header-ribbon', {
                displayFrequentlyAskedQuestions: config.frequentlyAskedQuestions && config.frequentlyAskedQuestions.display
            }, function() {
                $('#am-legal-notice-link').on('click tap', function(event) {
                    event.preventDefault();
                    $("#am-legal-notice-modal-contents").modal("show");
                });
                $('#am-faq-link').on('click tap', function(event) {
                    event.preventDefault();
                    $("#am-faq-modal-contents").modal("show");
                });
                $('#am-menu-btn').on('click tap', function() {
                    $(this).parent().toggleClass('am-open');
                });
            });
        }
    };


    /**
     * Instantiates the map according to the information contained in the config object
     *
     * @param {Object} config - Object containing the configuration of the current project
     */    
    module.MainController.prototype._instantiateMap = function(config, displayWelcomingModal, geographicBorders, geographicBordersEPCI, outerDelimitations) {
        var self = this;

        // Get the map options
        var options = {
            "preferCanvas": true,
            "fadeAnimation": false,
            "zoomAnimation": true,
            "zoomAnimationThreshold": 10,
            "wheelDebounceTime": 40,
            "wheelPxPerZoomLevel": 120,
            "minZoom": 11,
            "maxZoom": 19,
            "zoomControl": false
        };
        config.mapOptions.attributionControl = false;
        if (config.mapOptions.maxBounds) {
            var lowerLeftCorner  = config.mapOptions.maxBounds.lowerLeftCorner.slice();  // shallow copy of array
            var upperRightCorner = config.mapOptions.maxBounds.upperRightCorner.slice(); // shallow copy of array
            config.mapOptions.maxBounds = L.latLngBounds(L.latLng(lowerLeftCorner), L.latLng(upperRightCorner));
        }
        var zoomControlOptions = {};
        if (config.mapOptions.zoomControl) {
            zoomControlOptions = am.utils.mergeObjects({
                "position": "bottomleft",
                "zoomInTitle": am.translator.translate("zoomIn"),
                "zoomOutTitle": am.translator.translate("zoomOut")
            }, config.mapOptions.zoomControl);
            config.mapOptions.zoomControl = false;
        }
        var mapOptions = am.utils.mergeObjects(options, config.mapOptions);

        // Instantiate the map object and add getter/setter methods to it in order to access/modify its base layer
        this._map = L.map(config.mapDomElement, mapOptions);
        this._map._baseLayer = undefined;
        this._map.getBaseLayer = function() {
            return this._baseLayer;
        };
        this._map.setBaseLayer = function(layer) {
            if (this._baseLayer && this._baseLayer !== layer) {
                this.removeLayer(this._baseLayer);
            }
            if (!this.hasLayer(layer)) {
                this.addLayer(layer);
            }
            this._baseLayer = layer;
            if (layer.bringToBack) {
                layer.bringToBack();
            } else if (layer.eachLayer) {
                layer.eachLayer(function (l) {
                    l.bringToBack();
                });
            }
        };

        // Add an attribution control to the map
        L.control.attribution(mapOptions.attributionControlOptions).addTo(this._map);

        // Add a base layer to the map if required
        if (mapOptions.baseLayer) {
            var layerName = mapOptions.baseLayer.name;
            var layerConstructor = eval("am.utils." + layerName[0].toLowerCase() + layerName.substr(1) + "Layer");
            if (layerConstructor instanceof Function) {
                this._map.setBaseLayer(layerConstructor(mapOptions.baseLayer.apiKey, mapOptions.baseLayer.year));
            } else {
                throw new Error("Cannot find the function creating a new base layer of type '" + layerName + "'");
            }
        }

        // Ajout d'une couche contenant les limites des parcelles cadastrales, si nécessaire
        if (mapOptions.parcelLayer) {
            var options = am.utils.mergeObjects({
                pane: 'tilePane',
                interactive: false,
                bubblingMouseEvents: false,
                minZoom: 18,
                maxZoom: 20,
                maxNativeZoom: 19,
                vectorTileLayerStyles: {
                    arrondissement: { stroke: false, fill: false },
                    feuille: { stroke: false, fill: false },
                    borne_limite_propriete: { stroke: false, fill: false },
                    localisant: { stroke: false, fill: false },
                    batiment: { stroke: false, fill: false },
                    departement: { stroke: false, fill: false },
                    commune: { stroke: false, fill: false },
                    parcelle: am.utils.mergeObjects({
                        stroke: true,
                        weight: 2,
                        color: "white",
                        fill: false
                    }, mapOptions.parcelLayer.hasOwnProperty('options') ? mapOptions.parcelLayer.options.style : {})
                }
            }, mapOptions.parcelLayer.options);
            var url = mapOptions.parcelLayer.hasOwnProperty('url') ? mapOptions.parcelLayer.url : 'https://wxs.ign.fr/parcellaire/geoportail/tms/1.0.0/PCI/{z}/{x}/{y}.pbf';
            L.vectorGrid.protobuf(url, options).addTo(this._map);
        }

        // #1164
        if (outerDelimitations !== undefined && outerDelimitations.hasOwnProperty('features') && outerDelimitations.features.length > 0) {
            this._map.createPane('outerDelimitationsPane');
            var oOuterDelimitationsLayer = L.geoJSON(outerDelimitations, {
                pane: 'outerDelimitationsPane',
                "style": {
                    "color": "#ffffff",
                    "weight": 2,
                    "opacity": 1,
                    "fill": false
                    //"fillOpacity": 0.2,
                    //"fillColor": '#ff7800'
                }
            });
            oOuterDelimitationsLayer.getContainer = function () {
                return this._map.getRenderer(this)._container;
            };
            oOuterDelimitationsLayer.addTo(this._map);
        }
        else {
            console.error('Error loading outerDelimitations : missing data');
        }

        // Add a layer containing the geographic delimitations of the current projet, if any
        if (geographicBorders !== undefined && geographicBorders.hasOwnProperty('features') && geographicBorders.features.length > 0) {
            // if EPCI border exist get his delimitation
            if(geographicBordersEPCI !== undefined && geographicBordersEPCI.hasOwnProperty('features') && geographicBordersEPCI.features.length > 0) {
                geographicBorders = geographicBordersEPCI;
            }
            
            var overlay = [[[[-90, -180], [-90, 180], [90, 180], [90, -180]]]]; // multipolygon
            geographicBorders.features.forEach(function(feature, iFeature) {
                if (feature.hasOwnProperty('geometry') && feature.geometry.hasOwnProperty('type') && feature.geometry.hasOwnProperty('coordinates')) {
                    var geometry = feature.geometry.coordinates;
                    if (feature.geometry.type.toLowerCase() === 'polygon') {
                        geometry = [geometry]; // force multipolygon type
                    }
                    geometry.forEach(function(polygon) {
                        polygon.forEach(function(ring, iRing) {
                            ring = ring.slice(1); // create a shallow copy and remove first point (to avoid repetition with the last one, cf. Leafet documentation https://leafletjs.com/reference-1.0.3.html#polygon)
                            if (iRing === 0) { // outer ring
                                var rewindedRing = ring.reverse().map(function(pt) { return pt.slice().reverse(); }); // change ring order
                                overlay[0].push(rewindedRing);
                            } else {
                                overlay.push(ring);
                            }
                        });
                    });
                } else {
                        console.warn('Feature #' + iFeature + ' of the GeoJSON file containing the territory boundaries is not correct');
                    }
                });
                L.polygon(overlay, {
                    pane: 'tilePane',
                    interactive: false,
                    bubblingMouseEvents: false,
                    stroke: true,
                    color: '#ffffff',
                    weight: 3,
                    fill: true,
                    fillColor: '#000000',
                    fillOpacity: 0.5
                }).addTo(this._map);
        } else if (config["initialState"] && config["initialState"].epciJson) {
            this._map.fitBounds(config["mapOptions"].maxBoundsArray);
            this._map.setMinZoom(this._map.getBoundsZoom(config["mapOptions"].epciMaxBoundsArray) - 1);
            this._map.setMaxBounds(config["mapOptions"].epciMaxBounds);

            this._map.on('drag', function () {
                self._map.panInsideBounds(config["mapOptions"].epciMaxBoundsArray, { animate: false });
            });

            this._map.createPane('epciPane');
            var oLayer = L.geoJSON(config["initialState"].epciJson, {
                pane: 'epciPane',
                "style": {
                    "color": "#ff7800",
                    "weight": 2,
                    "opacity": 1,
                    "fillOpacity": 0.2,
                    "fillColor": '#ff7800'
                }
            });
            if (!oLayer.options) {
                oLayer.options = {};
            }
            oLayer.options.maxZoom = 13;
            oLayer.options.otherMaxZoom = 15;
            oLayer.on('add', function (event) {
                event.target.getContainer().setAttribute("class", "leaflet-zoom-animated customGeojsonLayer");
            }, this);
            oLayer.getContainer = function () {
                return this._map.getRenderer(this)._container;
            };
            this._map.on('zoomend', function (event) {
                var newZoomLevel = event.target.getZoom();
                if ((oLayer.options.hasOwnProperty('maxZoom') && newZoomLevel > oLayer.options.maxZoom) ||
                    (oLayer.options.hasOwnProperty('minZoom') && newZoomLevel < oLayer.options.minZoom)) {
                    oLayer.remove();
                } else {
                    oLayer.addTo(event.target);
                }
            });
            oLayer.addTo(this._map);
        } 
        // Add a north arrow to the map if required
        if (mapOptions.northArrow) {
            am.utils.onDocumentReady(function() {
                var northArrow = L.control({position: "bottomleft"});
                northArrow.onAdd = function (map) {
                    var div = L.DomUtil.create("div", "am-north-arrow");
                    div.innerHTML = '<img src="/img/pics/north-arrow.png">';
                    return div;
                };
                northArrow.addTo(self._map);
            });
        }

        // Add a zoom control to the map if required
        if (Object.keys(zoomControlOptions).length > 0) {
            am.utils.onDocumentReady(function() {
                self._map.addControl(L.control.zoom(zoomControlOptions));
            });
        }

        // Add a welcome modal window if required
        if (config.welcomingModalWindow && displayWelcomingModal) {
            var modalWindow = $('<div>').addClass("am-welcome-modal").get(0);
            am.utils.preventMapInteractionOverElement(modalWindow);
            this._map._controlContainer.appendChild(modalWindow);
            am.templateManager.fillElementWithTemplate(modalWindow, 'welcome-modal', {}, function($container){
                $("#am-welcome-modal-contents").modal({
                    backdrop: 'static',
                    show: true,
                });

                if (g_bUnsupported) {
                    $('#am-welcome-modal-contents button').hide();
                    $('#am-welcome-modal-contents .am-welcome-custom-msg').removeClass('hidden');
                    $('#am-welcome-modal-contents .am-welcome-custom-msg').html(am.translator.translate("browserUnsupported"));
                }
            });
        }

        // Add the legal notice modal window
        var legalWindow = $('<div class="am-legal-notice-modal">').get(0);
        am.utils.preventMapInteractionOverElement(legalWindow);
        this._map._controlContainer.appendChild(legalWindow);
        am.templateManager.fillElementWithTemplate(legalWindow, 'legal-notice-modal', {}, function($container){
            var $modalContents = $("#am-legal-notice-modal-contents");
            $modalContents.modal({
                backdrop: 'static',
                show: false
            });
        });

        // Add the FAQ modal window
        if (this._config.hasOwnProperty('frequentlyAskedQuestions') && this._config.frequentlyAskedQuestions.display) {
            var faqWindow = $('<div class="am-faq-modal">').get(0);
            am.utils.preventMapInteractionOverElement(faqWindow);
            this._map._controlContainer.appendChild(faqWindow);
            am.templateManager.fillElementWithTemplate(faqWindow, 'faq-modal', {
                showContactForm: this._config.frequentlyAskedQuestions.includeContactForm
            }, function($container){
                var $modalContents = $("#am-faq-modal-contents");
                $modalContents.modal({
                    backdrop: 'static',
                    show: false
                });
                $modalContents.find('.am-inline-question-link').on('click tap', function(event) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    var targetId = $(event.target).attr('href');
                    var $target = $('.am-faq-question[href="' + targetId + '"]');
                    $modalContents.scrollTop($target.position().top);
                    setTimeout(function() { 
                        if ($target.is('.collapsed')) { 
                            $target.click();
                        }
                    }, 300);
                });
                var $requestForm = $modalContents.find('form');
                $requestForm.on('submit', function(event) {
                    event.preventDefault();

                    // Désactivation du bouton
                    var $submitButton = $(this).find('[type="submit"]');
                    $submitButton.prop('disabled', true);
                    var $messageContainer = $requestForm.find('#am-request-message-container');
                    $messageContainer.removeClass();
                    $messageContainer.addClass('alert alert-info');
                    $messageContainer.css('display', 'none');
                    $messageContainer.html('<i class="fa fa-spinner am-spinner"></i>' + 
                        am.translator.translate('requestSent'));
                    $messageContainer.slideDown();

                    // Get the form values as a plain JS object
                    var formValues = {};
                    $requestForm.serializeArray().forEach(function(element) {
                        formValues[element.name] = element.value;
                    });

                    // Construct the body of the email
                    var request = formValues['am-contact-form-request']
                        .replace(/&/g, '&amp;')
                        .replace(/</g, '&lt;')
                        .replace(/>/g, '&gt;')
                        .replace(/"/g, '&quot;');
                    var emailBody = am.translator.translate('newQuestionEmailBody').replace('[[ORIGINAL-REQUEST]]', request);

                    // Envoi de la requête
                    $.ajax({
                        data: {
                            mailRecipients: {
                                to: formValues['am-contact-form-email'],
                                bcc: 'support-cadastre'
                            },
                            mailSubject: am.translator.translate('newQuestionEmailSubject'),
                            mailBody: emailBody
                        },
                        type: "POST",
                        url: "/backend/processRequest.php",
                        success: function(msg) {
                            $messageContainer.removeClass();
                            $messageContainer.addClass('alert alert-success');
                            $messageContainer.html('<i class="fa-fw fa fa-check"></i>' + 
                                am.translator.translate('requestSuccessfullySent'));
                        },
                        error: function(jqXHR, errorText) {
                            $messageContainer.removeClass();
                            $messageContainer.addClass('alert alert-danger');
                            $messageContainer.html('<i class="fa-fw fa fa-times"></i>' + 
                                am.translator.translate('errorSendingRequest'));
                        },
                        complete: function() {
                            setTimeout(function() {
                                $submitButton.prop('disabled', false);
                                $messageContainer.html('');
                                $messageContainer.slideUp();
                            }, 5000);
                        }
                    });
                });
            });
        }
    };

    /**
     * Manage portrait orientation : disable all features for this layout
     */
    module.MainController.prototype._checkOrientation = function() {
        if (window.matchMedia("(orientation: portrait)").matches) {
            var $alertModalContents = $("#am-alert-modal-contents");
            if ($alertModalContents.length > 0) {
                $alertModalContents.modal('show');
            } else {
                var alertModalWindow = $('<div>').addClass("am-alert-modal").get(0);
                am.utils.preventMapInteractionOverElement(alertModalWindow);
                $('body').append(alertModalWindow);
                am.templateManager.fillElementWithTemplate(alertModalWindow, 'alert-modal', {}, function($container){
                    $("#am-alert-modal-contents").modal({
                        backdrop: 'static',
                        show: true,
                    });
                });
            }
            $('.leaflet-control-container').hide();
        } else {
            $("#am-alert-modal-contents").modal('hide');
            $('.leaflet-control-container').show();
        }
    };

    /**
     * Instantiates the (sub)controllers according to the information contained in the config object
     *
     * @param {Object} config - Object containing the configuration of the current project
     */
    module.MainController.prototype._instantiateControllers = function(config) {
        config.controllers.forEach(function(controller) {
            controller.options.geographicBorders = config.geographicBorders;
            var constructFunction = eval("am.utils." + controller.name[0].toLowerCase() + controller.name.substr(1));
            if (constructFunction instanceof Function) {
                this._controllers.push(constructFunction(this, controller.options));
            } else {
                throw new Error("Cannot find the function creating a new instance of class am." + controller.name);
            }
        }, this);
    };

    /**
     * Registers the event handlers associated with the current project
     *
     * @param {Object} config - Object containing the configuration of the current project
     */
    module.MainController.prototype._registerEventHandlers = function(config) {
        am.eventManager.register('new_address_entered', this._handleNewAddressEvent, this);
        am.eventManager.register('new_feature_selection', this._handleNewFeatureSelection, this);
        am.eventManager.register('feature_added_to_selection', this._handleFeatureAddedToSelection, this);
        am.eventManager.register('feature_removed_from_selection', this._handleFeatureRemovedFromSelection, this);
        am.eventManager.register('feature_selection_cleared', this._handleFeatureSelectionCleared, this);
        am.eventManager.register('address_search_field_cleared', this._removeMarker, this);
        am.eventManager.register('address_search_field_updated', this._setAddress, this);
        am.eventManager.register('info_panel_visible', this._handleInfoPanelVisible, this);
        am.eventManager.register('info_panel_hidden', this._handleInfoPanelHidden, this);
        am.eventManager.register('update_url', this._handleUpdateUrl, this);
        am.eventManager.register('tracking_click', this._trackingClick, this); // #2747

        // Add en event listener to the map in order to update the URL each time the map is zoomed or paned
        this._map.on('moveend', this._updateUrlAfterMapMove, this);
    };

    /**
     * Defines callbacks associated with global view elements located outside of the map and panel blocks
     * @param {Object} config - Object containing the configuration of the current project
     * @private
     */
    module.MainController.prototype._defineViewCallbacks = function(config) {
        // Contact form
        $('form.am-contact-request-form').on('submit', am.utils.contactFormValidationCallback);
    };

    /**
     * #2395 Charge la page des résultats avec les paramètres mis en URL (partage de projet)
     * #2435 pour partager
     */
    module.MainController.prototype._loadProject = function() {
        var urlParams = am.utils.getUrlParameters();

        // Zoom the map to the correct location, if required, and then select the appropriate feature(s) once the map has
        // finished zooming
        if (urlParams.hasOwnProperty('mapCenter') && urlParams.hasOwnProperty('mapZoom')) {
            // Map needs to be moved
            if (this._map.getCenter().distanceTo(urlParams.mapCenter) > 1.0/*meter*/ || this._map.getZoom() != urlParams.mapZoom) {
                // Select the correct feature(s)
                if (urlParams.hasOwnProperty('selectedFeatureIds')) {
                    var self = this;
                    this._map.once('moveend', function() {
                        self._loadingProject = true;
                        am.eventManager.trigger('select_features_by_id', {
                            ids: urlParams.selectedFeatureIds,
                            emitEvent: true
                        });
                    });
                }

                // Move the map to its previous location
                this._map.setView(urlParams.mapCenter, urlParams.mapZoom, {
                    duration: 0.5
                });
            }
            // Map is already at the right location
            else {
                if (urlParams.hasOwnProperty('selectedFeatureIds')) {
                    this._loadingProject = true;
                    am.eventManager.trigger('select_features_by_id', {
                        ids: urlParams.selectedFeatureIds,
                        emitEvent: false
                    });
                } else {
                    am.eventManager.trigger('clear_feature_selection');
                }
            }
        }
    };

    /**
     * Unregisters the event handlers associated with the current project
     */
    module.MainController.prototype._unregisterEventHandlers = function() {
        am.eventManager.unregister('new_address_entered', this._handleNewAddressEvent, this);
        am.eventManager.unregister('new_feature_selection', this._handleNewFeatureSelection, this);
        am.eventManager.unregister('feature_added_to_selection', this._handleFeatureAddedToSelection, this);
        am.eventManager.unregister('feature_removed_from_selection', this._handleFeatureRemovedFromSelection, this);
        am.eventManager.unregister('feature_selection_cleared', this._handleFeatureSelectionCleared, this);
        am.eventManager.unregister('address_search_field_updated', this._setAddress, this);
        am.eventManager.unregister('address_search_field_cleared', this._removeMarker, this);
        am.eventManager.unregister('info_panel_visible', this._handleInfoPanelVisible, this);
        am.eventManager.unregister('info_panel_hidden', this._handleInfoPanelHidden, this);
        am.eventManager.unregister('update_url', this._handleUpdateUrl, this);
        am.eventManager.unregister('tracking_click', this._trackingClick, this); // #2747

        // Add en event listener to the map in order to update the URL each time the map is zoomed or paned
        this._map.off('moveend', this._updateUrlAfterMapMove, this);
    };

    /**
     * Handles the event emitted when the user enters a new address in the address search field
     *
     * @param {Object} address - Object containing the location of the address entered by the user (the object is 
     *      expected to contain the following keys: "location" and "bounds" [optional]).
     */
    module.MainController.prototype._handleNewAddressEvent = function(address) {
        // Unselect previously selected features, if any
        am.eventManager.trigger('clear_feature_selection', false);
        this._handleFeatureSelectionCleared(false);

        // 
        if (address.bounds) {
            var padding = (window.matchMedia("all and (orientation: landscape)").matches) ? 
                [0.25*this._map.getSize().x, 0] : // keep a margin of 1/4 screen width on both left and right sides in landscape mode
                [0, 0.25*this._map.getSize().y];  // keep a margin of 1/4 screen height on both top and bottom sides in portrait mode
            this._map.fitBounds(address.bounds, {
                padding: padding,
                duration: 0.5
            });
        } else {
            this._map.flyTo(address.location, this._map.getMaxZoom(), {
                duration: 0.5
            });
        }

        var _this = this;
        setTimeout(function() { // delay execution of the function in order to wait for the tiles to be loaded
            _this._displayMessageInfoPopup(address.location, true);
        }, 300);
    };

    /**
     * Handles the event emitted when a user clicks on a feature while no feature was previously selected
     *
     * @param {Object} featureInfo - Object containing various pieces of information about the feature on which the user
     *      clicked (the object is expected to contain the following attributes: "roofsideId", "buildingId", 
     *      "buildingBounds" and "pointLocation").
     */
    module.MainController.prototype._handleNewFeatureSelection = function(featureInfo) {
        // Add feature to the SolarInstallationModel
        am.solarInstallationModel.setRoofId(featureInfo.roofsideId);

        // Search the address of the feature on which the user clicked, and hide all widgets
        am.eventManager.trigger('display_address_of_location', featureInfo.pointLocation); // look for the address of the point passed as parameter, emits 'address_search_field_updated' once found
        am.eventManager.trigger('hide_address_search_field');
        am.eventManager.trigger('hide_roof_layer');
        am.eventManager.trigger('hide_base_layer_selector');
        $('body').addClass('am-map-controls-hidden');

        // Display a pop-up to ask the user for validation of the selection
        if (this._loadingProject) {
            this._displayInfoOnNewFeature(featureInfo);
            this._loadingProject = false;
        } else {
            var _this = this;
            setTimeout(function() { // delay execution of the function in order to wait for the tiles to be loaded
                _this._displayFeatureInfoPopup(featureInfo, true);
            }, 300);
        }
    };

    /**
     * Handles the event emitted when a user validates a feature previously selected
     *
     * @param {Object} featureInfo - Object containing various pieces of information about the feature on which the user
     *      clicked (the object is expected to contain the following attributes: "roofsideId", "buildingId",
     *      "buildingBounds" and "pointLocation").
     */
    module.MainController.prototype._displayInfoOnNewFeature = function(featureInfo) {
        // Prevent interaction with the map
        if (this._map.touchZoom)       this._map.touchZoom.disable();
        if (this._map.doubleClickZoom) this._map.doubleClickZoom.disable();
        if (this._map.scrollWheelZoom) this._map.scrollWheelZoom.disable();
        if (this._map.boxZoom)         this._map.boxZoom.disable();
        if (this._map.keyboard)        this._map.keyboard.disable();
        if (this._map.dragging)        this._map.dragging.disable();
        $(".leaflet-control-zoom").css("visibility", "hidden");

        // Display info on the selected feature
        featureInfo.address = this._address;
        am.eventManager.trigger('display_info_on_feature', featureInfo);

        // Update the URL to store the ID of the selected feature. Do this only AFTER the map has finished moving, so
        // that the map coordinates are updated (in the URL) BEFORE the selected feature ID is added to the URL. This
        // ensures that we don't get stuck in a loop when the user clicks on the "go to previous page" button of its
        // browser (otherwise we would first go back to the previous position, but with the feature alreay selected,
        // which would result in no change at all).
        setTimeout(function() {
            am.utils.addUrlParameter('selectedFeatureIds', [featureInfo.roofsideId]);
        }, 800);
    };

    /**
     * Handles the event emitted when a user clicks on a feature while at least one other feature was previously selected
     *
     * @param {Object} featureInfo - Object containing various pieces of information about the feature on which the user
     *      clicked (the object is expected to contain the following attributes: "roofsideId" and "buildingId").
     */
    module.MainController.prototype._handleFeatureAddedToSelection = function(featureInfo) {
        // Add feature to the SolarInstallationModel
        am.solarInstallationModel.addRoofId(featureInfo.roofsideId);

        // Notify the side panel that a new feature has been selected
        am.eventManager.trigger('feature_selection_changed');

        // Update the URL to store the ID of the newly selected feature
        var params = am.utils.getUrlParameters();
        params.selectedFeatureIds.push(featureInfo.roofsideId);
        am.utils.setUrlParameters(params);
    };

    /**
     * Handles the event emitted when a user unselects a feature but at least one other feature remains selected
     *
     * @param {Object} featureInfo - Object containing various pieces of information about the feature on which the user
     *      clicked (the object is expected to contain the following attributes: "roofsideId" and "buildingId").
     */
    module.MainController.prototype._handleFeatureRemovedFromSelection = function(featureInfo) {
        // Remove feature from the SolarInstallationModel
        am.solarInstallationModel.removeRoofId(featureInfo.roofsideId);

        // Notify the side panel that a new feature has been unselected
        am.eventManager.trigger('feature_selection_changed');

        // Update the URL to remove the ID of the newly unselected feature
        var params = am.utils.getUrlParameters();
        if (params.hasOwnProperty('selectedFeatureIds')) {
            var featureIds = params.selectedFeatureIds;
            params.selectedFeatureIds = featureIds.splice(featureIds.indexOf(featureInfo.roofsideId), 1);
        }
        am.utils.setUrlParameters(params);
    };

    module.MainController.prototype._fromPrivateApp = function(){
        var oParams = am.utils.getUrlParameters();
        return oParams.hasOwnProperty("token") && oParams.token ==="a380c164-24e0-4ccc-8ea1-779a82a8c21b";
    }
    /**
     * Handles the event emitted when the user unselects all the features
     *
     * @param {Boolean} clearAddressBar - Should the address search bar be cleared? Defaults to true
     */
    module.MainController.prototype._handleFeatureSelectionCleared = function(clearAddressBar) {
        // Restore interaction with the map
        if (this._map.touchZoom)       this._map.touchZoom.enable();
        if (this._map.doubleClickZoom) this._map.doubleClickZoom.enable();
        if (this._map.scrollWheelZoom) this._map.scrollWheelZoom.enable();
        if (this._map.boxZoom)         this._map.boxZoom.enable();
        if (this._map.keyboard)        this._map.keyboard.enable();
        if (this._map.dragging)        this._map.dragging.enable();
        $(".leaflet-control-zoom").css("visibility", "visible");

        // Restore visibility of the widgets
        am.eventManager.trigger('show_address_search_field');
        am.eventManager.trigger('show_base_layer_selector');
        am.eventManager.trigger('show_roof_layer');
        $('body').removeClass('am-map-controls-hidden');

        // Clear address search field
        clearAddressBar = (clearAddressBar == undefined) ? true : clearAddressBar;
        if (clearAddressBar) {
            am.eventManager.trigger('clear_search_field');
            am.eventManager.trigger('collapse_address_search_field');
        }

        // Hide feature information panel
        am.eventManager.trigger('hide_feature_info');

        // Update the URL to remove the property holding the selected feature IDs and the properties associated with the
        // side panel
        var params = am.utils.getUrlParameters();
        var newParams = {
            mapCenter: params.mapCenter,
            mapZoom:   params.mapZoom,
        };
        if (params.hasOwnProperty("token")){
            newParams.token = params.token;
        }
        am.utils.setUrlParameters(newParams);
    };
    
    /**
     * Handles the event emitted when the information panel is about to slide in
     *
     * @param {Object} panelInfo - Object containing some pieces of information about the side panel. This object is
     *      expected to contain the following keys: "reservedSpace" and "featureBounds".
     */
    module.MainController.prototype._handleInfoPanelVisible = function(panelInfo) {
        // Center the map on the selected feature, taking into account the space that will be occupied by the info panel
        // (do nothing if the panel is going to occupy the entire space)
        var marginTop     = panelInfo.reservedSpace[0];
        var marginRight   = panelInfo.reservedSpace[1];
        var marginBottom  = panelInfo.reservedSpace[2];
        var marginLeft    = panelInfo.reservedSpace[3];
        var mapDimensions = this._map.getSize();
        if (marginLeft + marginRight < 0.95 * mapDimensions.x && marginTop + marginBottom < 0.95 * mapDimensions.y) {
            this._map.fitBounds(panelInfo.featureBounds, {
                paddingTopLeft: [marginLeft, marginTop],
                paddingBottomRight: [marginRight, marginBottom],
                animate: true,
                duration: 0.5
            });
        }
    };


    module.MainController.prototype._setAddress = function(address) {
        this._address = address;
        $('.am-panel-contents .am-address .am-header-text').html(address);
    };

    module.MainController.prototype._removeMarker = function() {
        this._marker.remove();
    };

    /** 
     * Handles the event emitted when the information panel is about to slide out
     */
    module.MainController.prototype._handleInfoPanelHidden = function(panelInfo) {
        // do nothing
    };

    /**
     * Displays a popup informing the user that roofs can be selected by clicking on them
     *
     * @param {L.LatLng} pos - Location at which the popup should be displayed
     * @param {Boolean} addLocationMarker - Should a location marker be added beneath the popup? Defaults to false
     */
    module.MainController.prototype._displayMessageInfoPopup = function(pos, addLocationMarker) {
        this._marker.setLatLng(pos);
        this._marker.addTo(this._map);
    };

    /**
     * Displays a popup informing the user that roofs can be selected by clicking on them
     *
     * @param {L.LatLng} pos - Location at which the popup should be displayed
     * @param {Boolean} addLocationMarker - Should a location marker be added beneath the popup? Defaults to false
     */
    module.MainController.prototype._displayFeatureInfoPopup = function(featureInfo) {
        var minWidth = Math.min($(window).width() - 40, 340);
        var maxWidth = Math.min($(window).width() - 10, 450);

        // Create the popup
        var popup = L.popup({
            closeButton: true,
            closeOnClick: true,
            autoPan: false,
            keepInView: true,
            minWidth: minWidth,
            maxWidth: maxWidth,
            maxHeight: 600,
            className: 'am-hidden am-popup am-surface-widget'
        });

        // Populate the popup with its contents
        var _this = this;
        var _oTplData = {
            irradiationClasses: am.utils.getIrradClasses(this._config),
            address: this._address,
            displayPublicFooter: true,
            displayMessageBelowTotalSurface: this._config.displayMessageBelowTotalSurface,
            isParking: this._config.hasOwnProperty('firstParkingFeatureId') ? featureInfo.roofsideId >= this._config.firstParkingFeatureId : false
        };
        am.templateManager.getTemplateAsHTMLElements('small-side-panel', _oTplData).then(function(htmlElements) {

            // Zoom the map on the selected feature
            //_this._map.fitBounds(featureInfo.buildingBounds, { duration: 0.25 });

            // Open the popup above the selected feature
            //setTimeout(function() {
                popup.setContent(htmlElements[0]);
                popup.setLatLng([featureInfo.buildingBounds.getNorth(), featureInfo.buildingBounds.getCenter().lng]);
                popup.on('add', function() {
                    var $popupContainer = $(".am-popup.am-surface-widget");
                    if ($popupContainer) {
                        var height = $popupContainer.outerHeight();
                        _this._map.fitBounds(featureInfo.buildingBounds, {
                            paddingTopLeft: [0, height],
                            duration: 0.25
                        });
                        $popupContainer.removeClass('am-hidden');
                    }
                });

                _this._map.openPopup(popup);
                am.utils.colorSolarPotentialDivs($('.am-popup'), "to top", _oTplData.irradiationClasses);
                am.utils.updateSolarPotentialDivs($('.am-popup'));
                $('.am-popup .am-panel-contents .am-address .am-header-text').html(_this._address);
                $('.am-popup #btn_am-submit').one('click tap', function(e) {
                    popup.remove();
                    _this._displayInfoOnNewFeature(featureInfo);
                });
                $('.am-popup .leaflet-popup-close-button').one('click tap', function(e) {
                    am.eventManager.trigger('clear_feature_selection');
                });
            //}, 300);

        });

        am.eventManager.register('feature_selection_cleared', function removePopup() {
            popup.remove();
            am.eventManager.unregister('feature_selection_cleared', removePopup); // self detach
        });
    };

    /**
     * Handles the event emitted when the page displayed in the side panel changes
     *
     * @param {Object} urlParameters - Object holding the parameters to be added to the URL
     */
    module.MainController.prototype._handleUpdateUrl = function(urlParameters) {
        am.utils.addUrlParameters(urlParameters);
    };

    /**
     * Stores the new map center and zoom in the URL each time the map is moved (i.e. zoomed or paned)
     */
    module.MainController.prototype._updateUrlAfterMapMove = function() {
        var mapCenter = this._map.getCenter();
        am.utils.addUrlParameters({
            mapCenter: [mapCenter.lat, mapCenter.lng],
            mapZoom:   this._map.getZoom()
        });
    };

    /**
     * #2747 suivi des clics
     * envoi dans la base de données les infos des clics
     */
    module.MainController.prototype._trackingClick = function (action) {
        var link = window.location.href; // #2747 on récupère la nouvelle adresse url pour le suivi des clics
        //console.log("link : ", link);
        if (typeof action == "undefined")
            action = "no_id"; // ne devrait pas exister, mais par sécurité
        // console.log("action : ", action);

        // sans id projet car partie publique !
        $.ajax({
            dataType: 'json',
            data: 'setClick=true&userUid=' + this._userid+'&action='+action+'&urlProject='+link,
            type: "POST",
            url: "/backend/setTrackingClicks.php",//#3038 il faut chercher le gestion du cadastre courant
            success: function(msg) {
                console.log(msg);
            },
            error: function(msg,stat, settings) {
                console.log("Error set click : ", msg, settings);
            }
        });
    };

    return module;

})(am || {});

